import { HeadCell } from '../../../models/TableProps';
import { LiveOrdersData } from '../../../models/LiveOrders';

export const LIVE_ORDERS_HEAD_CELLS: HeadCell<LiveOrdersData>[] = [
    {
        id: 'orderNumber',
        numeric: false,
        disablePadding: true,
        label: 'ORDER_NUMBER',
        sortable: true,
    },
    {
        id: 'date',
        numeric: true,
        disablePadding: false,
        label: 'DATE',
        sortable: true,
    },
    {
        id: 'price_net',
        numeric: true,
        disablePadding: false,
        label: 'PRICE_NET',
        sortable: true,
    },
    {
        id: 'price_gross',
        numeric: true,
        disablePadding: false,
        label: 'PRICE_GROSS',
        sortable: true,
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'STATUS',
        sortable: true,
    },
];
